document.addEventListener('DOMContentLoaded', function () {
    const addButtons = document.querySelectorAll('.add-company-btn');
    const flowDemo = document.getElementById('kp-jurentity-flow');

    if (addButtons.length || flowDemo) {
        const addBlockWrapper = document.querySelector('.add-company-wrapper');
        const addBlockInfo = document.querySelector('.add-company-info');
        const companiesTable = document.querySelector('.companies-table');
        const companyRow = document.querySelector('.company-row');
        const submitButtons = document.querySelector('.submit-buttons');
        const formBlock = document.getElementById('company-form-block');
        const cancelBtn = document.getElementById('cancel-form-btn');
        const tabs = document.querySelectorAll('.tab');
        const tabContents = document.querySelectorAll('.tab-content');
        const form = document.getElementById('add-company-form');
        const companyFilesInput = document.getElementById('company-files');
        const errorFilesContainer = document.getElementById('error-files');
        const submitTabField = document.getElementById('submit-tab');
        const dropzone = document.getElementById('company-dropzone');
        const uploadButton = document.getElementById('company-upload-button');
        const uploadList = document.getElementById('upload-list');
        const root = document.querySelector('.legal-company-page');
        const ajaxUrl = root?.dataset.ajaxUrl || '';
        const vCompanyName = root?.dataset.validationCompanyName || 'Вкажіть назву юридичної особи';
        const vCompanyCode = root?.dataset.validationCompanyCode || 'Вкажіть ЄДРПОУ / ІПН';
        const vCompanyAddress = root?.dataset.validationCompanyAddress || 'Вкажіть адресу';
        const vFopName = root?.dataset.validationFopName || 'Вкажіть ПІБ ФОП';
        const vFopCode = root?.dataset.validationFopCode || 'Вкажіть ІПН';
        const vFopAddress = root?.dataset.validationFopAddress || 'Вкажіть адресу ФОП';
        const vFilesRequired = root?.dataset.validationFilesRequired || 'Прикріпіть документи';
        const vFilesSizeTpl = root?.dataset.validationFilesSize || 'Розмір файлу %s перевищує ліміт у 50 MB. Завантажте файл меншого розміру.';
        const vFilesFormatTpl = root?.dataset.validationFilesFormat || 'Формат файлу %s не підтримується. Підтримуються PDF, PNG, JPG, JPEG, DOCX, DOC, RTF, TXT.';
        window.showModal = function (id) {
            document.getElementById(id).style.display = 'flex';
        };
        window.closeModal = function (id) {
            document.getElementById(id).style.display = 'none';
        };

        const successTitleEl = document.getElementById('kp-company-success-title');
        const successMessageEl = document.getElementById('kp-company-success-message');
        const defaultSuccessTitle = successTitleEl ? successTitleEl.textContent : '';
        const defaultSuccessMessage = successMessageEl ? successMessageEl.textContent : '';

        function setCompanySuccessModalContent(data) {
            if (successTitleEl) {
                successTitleEl.textContent = (data && data.success_title) || defaultSuccessTitle;
            }
            if (successMessageEl) {
                successMessageEl.textContent = (data && data.user_message) || defaultSuccessMessage;
            }
        }

        function resetCompanySuccessModalContent() {
            setCompanySuccessModalContent(null);
        }

        function toggleTab(tab) {
            const activeTab = tab.dataset.tab;
            submitTabField.value = activeTab;

            tabContents.forEach(tc => {
                const isActive = tc.classList.contains(activeTab);
                tc.classList.toggle('active', isActive);
                const inputs = tc.querySelectorAll('input');
                inputs.forEach(i => i.required = isActive);
            });

            const legalDesc = document.querySelector('.documents-description__legal');
            const fopDesc = document.querySelector('.documents-description__fop');
            if (legalDesc && fopDesc) {
                const isLegal = activeTab === 'legal';
                legalDesc.classList.toggle('active', isLegal);
                fopDesc.classList.toggle('active', !isLegal);
            }
        }

        tabs.forEach(tab => {
            tab.onclick = function (e) {
                e.preventDefault();
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                toggleTab(tab);
            };
        });

        const defaultTab = document.querySelector('.tabs .tab.active') || tabs[0];
        if (defaultTab) toggleTab(defaultTab);

        addButtons.forEach(btn => {
            btn.onclick = function () {
                closeModal('success-modal-overlay');
                root.classList.remove('is-hidden');
                companiesTable.classList.add('is-hidden');
                addBlockWrapper.classList.add('is-hidden');
                // Jur-entity flow (steps 1–4). Legacy form + file upload block stays hidden.
                if (flowDemo) {
                    flowDemo.classList.remove('is-hidden');
                    flowDemo.dispatchEvent(new CustomEvent('kp-jf-reset'));
                    if (addBlockInfo) {
                        addBlockInfo.classList.remove('is-hidden');
                    }
                } else if (formBlock) {
                    formBlock.classList.remove('is-hidden');
                    formBlock.style.removeProperty('display');
                    if (addBlockInfo) {
                        addBlockInfo.classList.remove('is-hidden');
                    }
                    if (submitButtons) {
                        submitButtons.classList.remove('is-hidden');
                    }
                }
            }
        });

        function resetFormState() {
            if (companyRow) {
                companiesTable.classList.remove('is-hidden');
                addBlockWrapper.classList.add('is-hidden');
            }
            else {
                companiesTable.classList.add('is-hidden');
                addBlockWrapper.classList.remove('is-hidden');
            }
            addBlockInfo.classList.add('is-hidden');
            submitButtons.classList.add('is-hidden');
            if (flowDemo) flowDemo.classList.add('is-hidden');
            if (formBlock) {
                formBlock.classList.add('is-hidden');
                formBlock.style.display = 'none';
            }
            form.reset();
            resetCompanySuccessModalContent();
            document.querySelectorAll('.error-message').forEach(e => e.innerText = '');
            errorFilesContainer.innerHTML = '';
            uploadList.innerHTML = '';
            selectedFiles = [];
            companyFilesInput.value = '';
            if (defaultTab) toggleTab(defaultTab);
            checkFormValidity();
        }

        if (cancelBtn) {
            cancelBtn.onclick = function () {
                resetFormState();
            };
        }

        function validateField(input, errorId, message) {
            if (!input.value.trim()) {
                input.setAttribute('aria-invalid', 'true');
                document.getElementById(errorId).innerText = message;
                return false;
            }
            input.removeAttribute('aria-invalid');
            document.getElementById(errorId).innerText = '';
            return true;
        }

        let selectedFiles = [];

        function getActiveTabFields() {
            const activeTab = document.querySelector('.tabs .tab.active')?.dataset.tab || 'legal';
            let fields = [];

            if (activeTab === 'legal') {
                fields = [
                    { input: form['company-name'], error: 'error-company-name', msg: vCompanyName },
                    { input: form['company-code'], error: 'error-company-code', msg: vCompanyCode },
                    { input: form['company-address'], error: 'error-company-address', msg: vCompanyAddress }
                ];
            } else {
                fields = [
                    { input: form['fop-name'], error: 'error-fop-name', msg: vFopName },
                    { input: form['fop-code'], error: 'error-fop-code', msg: vFopCode },
                    { input: form['fop-address'], error: 'error-fop-address', msg: vFopAddress }
                ];
            }

            return fields
        }

        function checkFormValidity() {
            const submitBtn = document.querySelector('.submit-buttons button[type="submit"]');
            if (!submitBtn) return;

            const fields = getActiveTabFields();
            let isValid = true;

            fields.forEach(f => {
                if (!f.input.value.trim()) {
                    isValid = false;
                }
            });

            if (selectedFiles.length === 0) {
                isValid = false;
            }

            if (isValid) {
                submitBtn.classList.remove('btn-success');
                submitBtn.classList.add('btn-primary');
                fields.forEach(f => {
                    f.input.removeAttribute('aria-invalid');
                });
                document.querySelectorAll('.error-message').forEach(e => e.innerText = '');
            } else {
                submitBtn.classList.remove('btn-primary');
                submitBtn.classList.add('btn-success');
            }
        }

        function renderFileList(files) {
            uploadList.innerHTML = '';
            files.forEach((file, index) => {
                const sizeKb = Math.round(file.size / 1024);
                const item = document.createElement('div');
                item.className = 'upload-list__item';
                item.dataset.index = index;
                item.innerHTML = `
              <div class="flex">
                <div class="upload-list__icon"></div>
                  <div class="upload__info">
                    <div class="upload-list__name">${file.name}</div>
                    <div class="upload-list__size">${sizeKb} КБ</div>
                  </div>
                </div>
              <button type="button" class="upload-list__remove" aria-label="Видалити файл">✕</button>`;
                uploadList.appendChild(item);
            });
        }

        function syncInputFromSelected() {
            const dt = new DataTransfer();
            selectedFiles.forEach(file => dt.items.add(file));
            companyFilesInput.files = dt.files;
        }

        function showUploadToast(title, message) {
            const container = document.getElementById('toast-container');
            if (!container) return;

            const toast = document.createElement('div');
            toast.className = 'toast';
            toast.innerHTML = `
                <?php echo esc_url( get_theme_file_uri( '/assets/src/icons/add-company.svg' ) ); ?>
                <div class="toast__icon"></div>
                <div class="toast__content">
                  <div class="toast__title">${title}</div>
                  <div class="toast__text">${message}</div>
                </div>
                <button type="button" class="toast__close" aria-label="Закрити">×</button>
              `;

            container.appendChild(toast);

            const close = () => {
                toast.remove();
            };

            toast.querySelector('.toast__close').addEventListener('click', close);
            setTimeout(close, 7000);
        }

        function filterValidFiles(files) {
            const allowedTypes = [
                'application/pdf',
                'image/png', 'image/jpeg', 'image/jpg',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'text/plain', 'application/rtf'
            ];
            const allowedExts = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'txt', 'rtf'];
            const maxSize = 50 * 1024 * 1024;

            const valid = [];
            let errorsHtml = '';

            Array.from(files).forEach(file => {
                let ok = true;

                if (file.size > maxSize) {
                    const msg = vFilesSizeTpl.replace('%s', file.name);
                    showUploadToast('Документ не завантажено!', msg);
                    ok = false;
                }

                const ext = file.name.split('.').pop().toLowerCase();
                if (!allowedTypes.includes(file.type) && !allowedExts.includes(ext)) {
                    const msg = vFilesFormatTpl.replace('%s', file.name);
                    showUploadToast('Документ не завантажено!', msg);
                    ok = false;
                }

                if (ok) {
                    valid.push(file);
                }
            });

            errorFilesContainer.innerHTML = errorsHtml;
            return valid;
        }

        function appendFiles(newFiles) {
            const validNew = filterValidFiles(newFiles);
            if (!validNew.length) return;

            const map = new Map(selectedFiles.map(f => [f.name + '|' + f.size, f]));
            validNew.forEach(file => {
                const key = file.name + '|' + file.size;
                map.set(key, file);
            });

            selectedFiles = Array.from(map.values());
            syncInputFromSelected();
            renderFileList(selectedFiles);
            checkFormValidity();
        }

        tabs.forEach(tab => {
            tab.onclick = function (e) {
                e.preventDefault();
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                toggleTab(tab);
                checkFormValidity();
            };
        });

        companyFilesInput.addEventListener('change', function () {
            appendFiles(this.files);
            this.value = '';
        });

        uploadButton.addEventListener('click', function () {
            companyFilesInput.click();
        });

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
        });

        ['dragenter', 'dragover'].forEach(eventName => {
            dropzone.addEventListener(eventName, function () {
                dropzone.classList.add('is-dragover');
            });
        });

        ['dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, function () {
                dropzone.classList.remove('is-dragover');
            });
        });

        dropzone.addEventListener('drop', function (e) {
            appendFiles(e.dataTransfer.files);
        });

        uploadList.addEventListener('click', function (e) {
            const btn = e.target.closest('.upload-list__remove');
            if (!btn) return;

            const item = btn.closest('.upload-list__item');
            const removeIndex = parseInt(item.dataset.index, 10);

            selectedFiles.splice(removeIndex, 1);
            syncInputFromSelected();
            renderFileList(selectedFiles);
            checkFormValidity();
        });

        const allFormInputs = form.querySelectorAll('input[type="text"], input[type="number"]');
        allFormInputs.forEach(input => {
            input.addEventListener('input', checkFormValidity);
        });

        checkFormValidity();

        function appendCompanyRow(company) {
            const tbody = document.querySelector('.woocommerce-companies-table tbody');
            if (!tbody || !company) return;

            const tr = document.createElement('tr');
            tr.className = 'company-row';
            tr.innerHTML = `<td class="company-name" data-title="Назва">
                              <strong>${company.title}</strong>
                            </td>
                            <td class="company-code" data-title="ЄДРПОУ / ІПН">
                              ${company.code}
                            </td>
                            <td class="company-address" data-title="Адреса">
                              ${company.address}
                            </td>
                            <td class="company-status" data-title="Статус">
                              <span class="status-badge status-badge--${company.status}">
                                ${company.status_label}
                              </span>
                            </td>
                            <td class="company-date" data-title="Дата додавання">
                              <time datetime="${company.date_iso}">
                                ${company.date_human}
                              </time>
                            </td>`;
            tbody.prepend(tr);
        }

        function handleAddCompanySuccess(data) {
            appendCompanyRow(data.company);
            resetFormState();
            setCompanySuccessModalContent(data);
            root.classList.add('is-hidden');
            companiesTable.classList.remove('is-hidden');
            addBlockWrapper.classList.add('is-hidden');
            showModal('success-modal-overlay');
        }

        /**
         * Legacy add-company form (with required file uploads).
         *
         * @param {{ scrollToFormOnError?: boolean, appendJfFields?: (fd: FormData) => void }} [options]
         */
        function submitAddCompany(options) {
            const opts = options || {};
            const scrollToFormOnError = !!opts.scrollToFormOnError;
            const appendJfFields = typeof opts.appendJfFields === 'function' ? opts.appendJfFields : null;

            const activeTabEl = document.querySelector('.tabs .tab.active');
            if (!activeTabEl || !form) return;
            const activeTab = activeTabEl.dataset.tab;
            const fields = getActiveTabFields();
            let valid = true;

            fields.forEach(f => {
                if (!validateField(f.input, f.error, f.msg)) valid = false;
            });

            if (!selectedFiles.length) {
                companyFilesInput.setAttribute('aria-invalid', 'true');
                showUploadToast(vFilesRequired, '');
                valid = false;
            } else {
                companyFilesInput.removeAttribute('aria-invalid');
            }

            if (!valid) {
                if (scrollToFormOnError && formBlock) {
                    formBlock.classList.remove('is-hidden');
                    formBlock.style.removeProperty('display');
                    if (submitButtons) {
                        submitButtons.classList.remove('is-hidden');
                    }
                    formBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                showModal('error-modal-overlay');
                return;
            }

            const fd = new FormData();
            fd.append('action', 'add_company');
            fd.append('add_company_nonce', form['add_company_nonce'].value);
            fd.append('submit_tab', activeTab);
            fd.append('is_ajax', '1');
            fields.forEach(f => fd.append(f.input.name, f.input.value));
            selectedFiles.forEach(file => fd.append('company-files[]', file));
            if (appendJfFields) {
                appendJfFields(fd);
            }

            fetch(ajaxUrl, {
                method: 'POST',
                body: fd,
            })
                .then(r => r.json())
                .then((data) => {
                    if (data && data.success) {
                        handleAddCompanySuccess(data);
                    } else {
                        showModal('error-modal-overlay');
                    }
                })
                .catch(() => {
                    showModal('error-modal-overlay');
                });
        }

        if (flowDemo) {
            // Step 4: submit company + document upload (legacy add_company).
            const KP_JF_SUBMIT_COMPANY_ENABLED = true;

            const jfTabs = flowDemo.querySelectorAll('[data-kp-jf-step]');
            const jfPanels = flowDemo.querySelectorAll('[data-kp-jf-panel]');
            const ajaxView = typeof main !== 'undefined' && main.ajaxUrl ? main.ajaxUrl : '';
            const nonceView = typeof main !== 'undefined' && main.nonce ? main.nonce : '';
            const edrInput = document.getElementById('kp-jf-edr-input');
            const lookupBtn = document.getElementById('kp-jf-lookup-btn');
            const lookupErr = document.getElementById('kp-jf-lookup-error');
            const resultGrid = document.getElementById('kp-jf-result-grid');
            const resultErr = document.getElementById('kp-jf-result-error');
            const confirmTitle = document.getElementById('kp-jf-confirm-title');
            const confirmLead = document.getElementById('kp-jf-confirm-lead');
            const confirmEntityBtn = document.getElementById('kp-jf-confirm-entity');
            const basBlockedWrap = document.getElementById('kp-jf-bas-blocked');
            const basBlockedText = document.getElementById('kp-jf-bas-blocked-text');
            const backSearchBtn = document.getElementById('kp-jf-back-to-search');
            const codeLabel = document.getElementById('kp-jf-code-label');
            const lookupBtnDefault = lookupBtn ? lookupBtn.textContent : '';

            const JF_LABEL = { legal: 'ЄДРПОУ', fop: 'ІПН' };
            const JF_PH = { legal: 'Введіть код ЄДРПОУ', fop: 'Введіть ІПН' };

            let lastEdrPayload = null;

            /** 8 digits = legal, 10 = FOP; overrides wrong entity tab at lookup/download. */
            function resolveJfEntityFromEdr(edr, hint, name) {
                const digits = String(edr || '').replace(/\D/g, '');
                if (digits.length === 10) return 'fop';
                if (digits.length === 8) return 'legal';
                if (name) {
                    const u = String(name).toUpperCase();
                    if (/\b(ФОП|ФІЗИЧНА\s+ОСОБА[\s-]*ПІДПРИЄМЕЦЬ)\b/.test(u)) return 'fop';
                }
                return hint === 'fop' ? 'fop' : 'legal';
            }

            function getJfContractEntity() {
                if (!lastEdrPayload) return 'legal';
                const data = collectContractData();
                const code =
                    (data.code && String(data.code).replace(/\D/g, '')) ||
                    String(lastEdrPayload.row?.EDR || lastEdrPayload.data?.EDR || '').replace(/\D/g, '');
                const name = data.name || lastEdrPayload.data?.name || '';
                return resolveJfEntityFromEdr(code, lastEdrPayload.entity, name);
            }

            function getBasExistsMessage() {
                return (flowDemo && flowDemo.dataset.basExistsMessage) || '';
            }

            function isCounterpartyInBas(data) {
                if (!data || typeof data !== 'object') return false;
                if (data.kp_blocked_in_bas === true || data.kp_in_bas === true) return true;
                const st = parseInt(data.status, 10);
                return st === 2;
            }

            function showBasBlockedNotice(message) {
                const text = message || getBasExistsMessage();
                if (basBlockedText && text) basBlockedText.textContent = text;
                if (basBlockedWrap) basBlockedWrap.removeAttribute('hidden');
            }

            function hideBasBlockedNotice() {
                if (basBlockedWrap) basBlockedWrap.setAttribute('hidden', '');
            }

            function getJfRegisterContact() {
                const email = (root?.dataset.registerEmail || '').trim();
                const phone = (root?.dataset.registerPhone || '').trim();
                return { email, phone };
            }

            function extractJfFirstPhoneRaw(raw) {
                const s = String(raw || '').trim();
                if (!s) return '';
                const parts = s.split(/\s*(?:[,;]|\s+Телефон\s*\d*\s*:|\s+Phone\s*\d*\s*:)\s*/i);
                for (let i = 0; i < parts.length; i += 1) {
                    const part = String(parts[i] || '').trim();
                    if (part && /\d/.test(part)) return part;
                }
                return s;
            }

            function applyJfContactFieldsFromRegistry(d) {
                const reg = getJfRegisterContact();
                const registryEmail = String(d.email || '').trim();
                const registryPhone =
                    normalizeJfPhone(extractJfFirstPhoneRaw(d.tel || '')) ||
                    normalizeJfPhone(reg.phone) ||
                    '';

                const emailEl = document.getElementById('kp-jf-req-email');
                const phoneEl = document.getElementById('kp-jf-req-phone');

                if (emailEl) {
                    emailEl.value = registryEmail || reg.email;
                }
                if (phoneEl) {
                    phoneEl.value = registryPhone;
                }
            }

            let jfActivitiesLoaded = false;
            let jfActivitiesLoading = false;

            function setSigningMethod(method) {
                const val = method === 'postal' ? 'postal' : 'vchasno';
                const hidden = document.getElementById('kp-jf-req-signing-method');
                if (hidden) hidden.value = val;
                flowDemo.querySelectorAll('.kp-jf-signing-opt').forEach((btn) => {
                    btn.classList.toggle('is-active', btn.getAttribute('data-kp-jf-signing') === val);
                });
                const note = document.getElementById('kp-jf-req-signing-note');
                if (note) {
                    note.textContent =
                        val === 'postal'
                            ? 'Договір надішлють поштою після верифікації. Email може використовуватись для звʼязку.'
                            : 'Договір надішлють на email у Вчасно після верифікації.';
                }
            }

            let jfActivitiesItems = [];
            let jfActivityHighlightIndex = -1;

            function getJfActivitySearchEls() {
                return {
                    root: document.getElementById('kp-jf-req-activity-search'),
                    hidden: document.getElementById('kp-jf-req-activity'),
                    input: document.getElementById('kp-jf-req-activity-input'),
                    list: document.getElementById('kp-jf-req-activity-list'),
                    toggle: document.getElementById('kp-jf-req-activity-toggle'),
                };
            }

            function setJfActivitySearchEnabled(enabled, placeholder) {
                const { root, hidden, input, toggle } = getJfActivitySearchEls();
                if (!root || !hidden || !input) return;
                root.classList.toggle('kp-jf-search-select--disabled', !enabled);
                input.disabled = !enabled;
                if (toggle) {
                    toggle.disabled = !enabled;
                    toggle.tabIndex = enabled ? 0 : -1;
                }
                if (placeholder) input.placeholder = placeholder;
            }

            function closeJfActivityList() {
                const { input, list } = getJfActivitySearchEls();
                if (list) list.hidden = true;
                if (input) input.setAttribute('aria-expanded', 'false');
                jfActivityHighlightIndex = -1;
            }

            function openJfActivityList() {
                const { input, list } = getJfActivitySearchEls();
                if (!list || !input || input.disabled) return;
                renderJfActivityList(input.value);
                list.hidden = false;
                input.setAttribute('aria-expanded', 'true');
            }

            function selectJfActivityItem(item) {
                const { hidden, input } = getJfActivitySearchEls();
                if (!hidden || !input || !item) return;
                hidden.value = item.value || '';
                input.value = item.label || item.value || '';
                input.setAttribute('aria-invalid', 'false');
                closeJfActivityList();
            }

            function clearJfActivitySelection() {
                const { hidden, input } = getJfActivitySearchEls();
                if (hidden) hidden.value = '';
                if (input) {
                    input.value = '';
                    input.removeAttribute('aria-invalid');
                }
                closeJfActivityList();
            }

            function renderJfActivityList(filterText) {
                const { list, hidden } = getJfActivitySearchEls();
                if (!list) return;

                const q = String(filterText || '')
                    .trim()
                    .toLowerCase();
                const filtered = jfActivitiesItems.filter((item) => {
                    const label = String(item.label || '').toLowerCase();
                    const value = String(item.value || '').toLowerCase();
                    return !q || label.includes(q) || value.includes(q);
                });

                list.innerHTML = '';
                jfActivityHighlightIndex = -1;

                if (!filtered.length) {
                    const li = document.createElement('li');
                    li.className = 'kp-jf-search-select__empty';
                    li.textContent = q ? 'Нічого не знайдено.' : 'Список порожній.';
                    list.appendChild(li);
                    return;
                }

                filtered.forEach((item, index) => {
                    const li = document.createElement('li');
                    li.className = 'kp-jf-search-select__option';
                    li.setAttribute('role', 'option');
                    li.textContent = item.label || item.value || '';
                    if (hidden && hidden.value && hidden.value === item.value) {
                        li.classList.add('is-selected');
                    }
                    li.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        selectJfActivityItem(item);
                    });
                    li.dataset.index = String(index);
                    list.appendChild(li);
                });
            }

            function highlightJfActivityOption(delta) {
                const { list } = getJfActivitySearchEls();
                if (!list || list.hidden) return;
                const options = list.querySelectorAll('.kp-jf-search-select__option');
                if (!options.length) return;
                jfActivityHighlightIndex += delta;
                if (jfActivityHighlightIndex < 0) jfActivityHighlightIndex = options.length - 1;
                if (jfActivityHighlightIndex >= options.length) jfActivityHighlightIndex = 0;
                options.forEach((el, i) => {
                    el.classList.toggle('is-highlighted', i === jfActivityHighlightIndex);
                });
                options[jfActivityHighlightIndex].scrollIntoView({ block: 'nearest' });
            }

            function confirmJfActivityHighlight() {
                const { list } = getJfActivitySearchEls();
                if (!list || list.hidden) return;
                const highlighted = list.querySelector('.kp-jf-search-select__option.is-highlighted');
                if (highlighted) {
                    highlighted.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                }
            }

            function syncJfActivityInputFromHidden() {
                const { hidden, input } = getJfActivitySearchEls();
                if (!hidden || !input || !hidden.value) return;
                const found = jfActivitiesItems.find((item) => item.value === hidden.value);
                if (found) input.value = found.label || found.value || '';
            }

            function isJfActivityValueAllowed(value) {
                if (!value) return false;
                return jfActivitiesItems.some((item) => item.value === value);
            }

            function getJfActivityLabelByValue(value) {
                const found = jfActivitiesItems.find((item) => item.value === value);
                return found ? found.label || found.value || '' : '';
            }

            function initJfActivitySearchSelect(items) {
                jfActivitiesItems = Array.isArray(items) ? items : [];
                const wrap = document.getElementById('kp-jf-req-activity-wrap');
                const { input, toggle } = getJfActivitySearchEls();

                clearJfActivitySelection();

                if (wrap) wrap.classList.remove('kp-jf-req-field--loading');

                if (!jfActivitiesItems.length) {
                    setJfActivitySearchEnabled(false, 'Немає варіантів у довіднику');
                    return;
                }

                setJfActivitySearchEnabled(true, 'Почніть вводити для пошуку…');

                if (input && !input.dataset.kpJfActivityBound) {
                    input.dataset.kpJfActivityBound = '1';
                    input.addEventListener('focus', () => openJfActivityList());
                    input.addEventListener('input', () => {
                        const { hidden } = getJfActivitySearchEls();
                        if (hidden) hidden.value = '';
                        openJfActivityList();
                    });
                    input.addEventListener('keydown', (e) => {
                        if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            openJfActivityList();
                            highlightJfActivityOption(1);
                        } else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            openJfActivityList();
                            highlightJfActivityOption(-1);
                        } else if (e.key === 'Enter') {
                            if (!getJfActivitySearchEls().list?.hidden) {
                                e.preventDefault();
                                confirmJfActivityHighlight();
                            }
                        } else if (e.key === 'Escape') {
                            closeJfActivityList();
                        }
                    });
                    input.addEventListener('blur', () => {
                        window.setTimeout(() => {
                            const { hidden, input: inp } = getJfActivitySearchEls();
                            if (!inp || !hidden) return;
                            if (!hidden.value) {
                                inp.value = '';
                                return;
                            }
                            syncJfActivityInputFromHidden();
                            if (!isJfActivityValueAllowed(hidden.value)) {
                                hidden.value = '';
                                inp.value = '';
                            }
                        }, 150);
                    });
                }

                if (toggle && !toggle.dataset.kpJfActivityBound) {
                    toggle.dataset.kpJfActivityBound = '1';
                    toggle.addEventListener('click', () => {
                        const { list, input: inp } = getJfActivitySearchEls();
                        if (!inp || inp.disabled) return;
                        if (list && !list.hidden) closeJfActivityList();
                        else openJfActivityList();
                    });
                }

                if (!window.__kpJfActivityDocClickBound) {
                    window.__kpJfActivityDocClickBound = true;
                    document.addEventListener('click', (e) => {
                        const root = document.getElementById('kp-jf-req-activity-search');
                        if (!root || root.contains(e.target)) return;
                        closeJfActivityList();
                    });
                }
            }

            function populateActivitiesSelect(items) {
                initJfActivitySearchSelect(items || []);
            }

            async function loadJfActivities(force) {
                if (jfActivitiesLoaded && !force) return;
                if (jfActivitiesLoading) return;
                const ajaxUrl = typeof main !== 'undefined' && main.ajaxUrl ? main.ajaxUrl : '';
                const nonce = typeof main !== 'undefined' && main.nonce ? main.nonce : '';
                if (!ajaxUrl || !nonce) return;

                jfActivitiesLoading = true;
                const wrap = document.getElementById('kp-jf-req-activity-wrap');
                if (wrap) wrap.classList.add('kp-jf-req-field--loading');

                try {
                    const fd = new FormData();
                    fd.append('action', 'kitan_sync_bas_activities');
                    fd.append('nonce', nonce);
                    const r = await fetch(ajaxUrl, { method: 'POST', body: fd, credentials: 'same-origin' });
                    const j = await r.json();
                    if (!j.success || !j.data || !Array.isArray(j.data.activities)) {
                        const msg = (j.data && j.data.message) || 'Не вдалося завантажити види діяльності.';
                        populateActivitiesSelect([]);
                        const note = document.getElementById('kp-jf-req-activity-note');
                        if (note) note.textContent = msg;
                        return;
                    }
                    populateActivitiesSelect(j.data.activities);
                    jfActivitiesLoaded = true;
                    const note = document.getElementById('kp-jf-req-activity-note');
                    if (note) note.textContent = 'Довідник з BAS (activities).';
                } catch (e) {
                    populateActivitiesSelect([]);
                    const note = document.getElementById('kp-jf-req-activity-note');
                    if (note) note.textContent = 'Мережева помилка при завантаженні видів діяльності.';
                } finally {
                    jfActivitiesLoading = false;
                }
            }

            function clearRequisitesEditableFields() {
                const reg = getJfRegisterContact();
                ['kp-jf-req-email', 'kp-jf-req-phone', 'kp-jf-req-iban', 'kp-jf-req-bank', 'kp-jf-req-fact-address', 'kp-jf-req-comment'].forEach((id) => {
                    const el = document.getElementById(id);
                    if (!el) return;
                    if (id === 'kp-jf-req-email') {
                        el.value = reg.email;
                    } else if (id === 'kp-jf-req-phone') {
                        el.value = normalizeJfPhone(reg.phone) || '';
                    } else {
                        el.value = '';
                    }
                });
                clearJfActivitySelection();
                jfActivitiesItems = [];
                setSigningMethod('vchasno');
            }

            function fillRequisitesPanel() {
                if (!lastEdrPayload) return;
                const d = lastEdrPayload.data || {};
                const row = lastEdrPayload.row || {};
                const codeLbl = document.getElementById('kp-jf-req-code-lbl');
                if (codeLbl) {
                    codeLbl.textContent = lastEdrPayload.entity === 'fop' ? 'ІПН' : 'ЄДРПОУ / ІПН';
                }
                const setv = (id, val) => {
                    const n = document.getElementById(id);
                    if (n) n.value = val == null || val === '' ? '' : String(val);
                };
                setv('kp-jf-req-name', d.name || '');
                setv('kp-jf-req-code', String(d.EDR || row.EDR || '').replace(/\D/g, '') || String(row.EDR || ''));
                setv('kp-jf-req-address', d.address || '');
                applyJfContactFieldsFromRegistry(d);
                setv('kp-jf-req-vat', d.vat || '');
                setv('kp-jf-req-kved', d.KVED || '');
                setv('kp-jf-req-signer', d.chief || '');
                setv('kp-jf-req-reg-status', d.reg_status || '');
                setv('kp-jf-req-reg-data', d.reg_data || '');
            }

            function escapeHtml(t) {
                if (t == null || t === '') return '';
                const e = document.createElement('div');
                e.textContent = String(t);
                return e.innerHTML;
            }

            function hideReqValidateError() {
                const box = document.getElementById('kp-jf-req-validate-error');
                if (box) {
                    box.hidden = true;
                    box.textContent = '';
                }
            }

            function showReqValidateError(msg) {
                const box = document.getElementById('kp-jf-req-validate-error');
                if (box) {
                    box.hidden = false;
                    box.textContent = msg;
                }
            }

            function extractRegistryScalar(data, keys) {
                if (!data || typeof data !== 'object') return '';
                for (let i = 0; i < keys.length; i += 1) {
                    const val = data[keys[i]];
                    if (val != null && String(val).trim() !== '') {
                        return String(val).trim();
                    }
                }
                return '';
            }

            function extractEdrRecordFromRegistry(data) {
                return extractRegistryScalar(data, [
                    'EDR_Registration_Record_number',
                    'edr_record',
                    'record_number',
                    'reg_record',
                    'record',
                    'nomer_zapysu',
                    'registration_record',
                ]);
            }

            function extractEdrRecordDateFromRegistry(data) {
                return extractRegistryScalar(data, [
                    'EDR_Registration_Record_date',
                    'edr_record_date',
                    'reg_record_date',
                ]);
            }

            function extractEpGrupFromRegistry(data) {
                return extractRegistryScalar(data, ['EP_GRUP', 'ep_grup']);
            }

            function extractEpStavkaFromRegistry(data) {
                return extractRegistryScalar(data, ['EP_STAVKA', 'ep_stavka']);
            }

            const jfEpGroupLabels = {
                1: 'перша',
                2: 'друга',
                3: 'третя',
                4: 'четверта',
            };

            function formatTaxStatusFromEpGrup(grup) {
                const digits = String(grup || '').replace(/\D/g, '');
                const label = jfEpGroupLabels[digits];
                if (!label) return '';
                return `єдиного податку (${label} група)`;
            }

            function extractTaxStatusFromRegistry(data) {
                const grup = extractEpGrupFromRegistry(data);
                return formatTaxStatusFromEpGrup(grup);
            }

            function collectContractData() {
                const gv = (id) => (document.getElementById(id)?.value ?? '').trim();
                return {
                    email: gv('kp-jf-req-email'),
                    iban: gv('kp-jf-req-iban').toUpperCase().replace(/\s/g, ''),
                    bank: gv('kp-jf-req-bank'),
                    comment: (document.getElementById('kp-jf-req-comment')?.value ?? '').trim(),
                    name: gv('kp-jf-req-name'),
                    code: gv('kp-jf-req-code'),
                    address: gv('kp-jf-req-address'),
                    factAddress: gv('kp-jf-req-fact-address'),
                    phone: gv('kp-jf-req-phone'),
                    signer: gv('kp-jf-req-signer'),
                    vat: gv('kp-jf-req-vat'),
                    regDate: gv('kp-jf-req-reg-data'),
                    edrRecord: lastEdrPayload
                        ? extractEdrRecordFromRegistry(lastEdrPayload.data || {})
                        : '',
                    edrRecordDate: lastEdrPayload
                        ? extractEdrRecordDateFromRegistry(lastEdrPayload.data || {})
                        : '',
                    epGrup: lastEdrPayload
                        ? extractEpGrupFromRegistry(lastEdrPayload.data || {})
                        : '',
                    epStavka: lastEdrPayload
                        ? extractEpStavkaFromRegistry(lastEdrPayload.data || {})
                        : '',
                    taxStatus: lastEdrPayload
                        ? extractTaxStatusFromRegistry(lastEdrPayload.data || {})
                        : '',
                    activity: gv('kp-jf-req-activity'),
                    activityLabel: getJfActivityLabelByValue(gv('kp-jf-req-activity')) || gv('kp-jf-req-activity-input'),
                    signingMethod: (document.getElementById('kp-jf-req-signing-method')?.value || 'vchasno').trim(),
                };
            }

            function hideContractError() {
                const box = document.getElementById('kp-jf-contract-error');
                if (box) {
                    box.hidden = true;
                    box.textContent = '';
                }
            }

            function showContractError(msg) {
                const box = document.getElementById('kp-jf-contract-error');
                if (box) {
                    box.hidden = false;
                    box.textContent = msg;
                }
            }

            function normalizeJfPhone(raw) {
                const single = extractJfFirstPhoneRaw(raw);
                const digits = String(single || '').replace(/\D/g, '');
                if (digits.length === 12 && digits.startsWith('380')) {
                    return `+${digits}`;
                }
                if (digits.length === 10 && digits.startsWith('0')) {
                    return `+38${digits}`;
                }
                if (digits.length === 9) {
                    return `+380${digits}`;
                }
                return '';
            }

            function validateRequisitesForContract() {
                const x = collectContractData();
                if (!x.email) return { ok: false, message: 'Вкажіть email для договору / Вчасно.' };
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(x.email)) {
                    return { ok: false, message: 'Перевірте формат email.' };
                }
                if (!x.phone) return { ok: false, message: 'Вкажіть телефон.' };
                if (!/^\+380\d{9}$/.test(normalizeJfPhone(x.phone))) {
                    return { ok: false, message: 'Телефон у форматі +380XXXXXXXXX (9 цифр після +380).' };
                }
                if (!x.iban) return { ok: false, message: 'Вкажіть IBAN.' };
                if (!/^UA\d{27}$/.test(x.iban)) {
                    return {
                        ok: false,
                        message: 'IBAN для України має містити рівно 29 символів: літери UA та 27 цифр.',
                    };
                }
                if (!x.bank) return { ok: false, message: 'Вкажіть банк.' };
                if (!x.factAddress) return { ok: false, message: 'Вкажіть фактичну адресу та назву закладу.' };
                if (!x.activity || !isJfActivityValueAllowed(x.activity)) {
                    const actInput = document.getElementById('kp-jf-req-activity-input');
                    if (actInput) actInput.setAttribute('aria-invalid', 'true');
                    return { ok: false, message: 'Оберіть вид діяльності зі списку.' };
                }
                if (x.signingMethod !== 'vchasno' && x.signingMethod !== 'postal') {
                    return { ok: false, message: 'Оберіть спосіб підписання документів.' };
                }
                return { ok: true, message: '' };
            }

            /** Highest step index the user may open (0 = search only). */
            let jfMaxUnlockedStep = 0;

            function syncJfTabLocks() {
                jfTabs.forEach((b) => {
                    const step = parseInt(b.getAttribute('data-kp-jf-step'), 10);
                    if (Number.isNaN(step)) return;
                    const locked = step > jfMaxUnlockedStep;
                    if (locked) {
                        b.setAttribute('data-kp-jf-locked', '1');
                        b.setAttribute('aria-disabled', 'true');
                    } else {
                        b.removeAttribute('data-kp-jf-locked');
                        b.setAttribute('aria-disabled', 'false');
                    }
                });
            }

            function setJfMaxUnlockedStep(stepIndex) {
                const n = parseInt(stepIndex, 10);
                if (Number.isNaN(n)) return;
                jfMaxUnlockedStep = Math.max(0, Math.min(5, n));
                syncJfTabLocks();
            }

            function unlockJfTabsThrough(stepIndex) {
                const n = parseInt(stepIndex, 10);
                if (Number.isNaN(n)) return;
                setJfMaxUnlockedStep(Math.max(jfMaxUnlockedStep, n));
            }

            function isJfDataAccuracyConfirmed() {
                const cb = document.getElementById('kp-jf-data-accuracy');
                return !!(cb && cb.checked);
            }

            function syncJfContractCreateEnabled() {
                const createBtn = document.getElementById('kp-jf-contract-create');
                if (!createBtn) return;
                const enabled = isJfDataAccuracyConfirmed();
                createBtn.disabled = !enabled;
                createBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
            }

            function resetJfDataAccuracyCheckbox() {
                const cb = document.getElementById('kp-jf-data-accuracy');
                const wrap = document.getElementById('kp-jf-data-accuracy-wrap');
                if (cb) cb.checked = false;
                if (wrap) wrap.classList.remove('is-invalid');
                syncJfContractCreateEnabled();
            }

            function resetJfFlowProgress() {
                jfMaxUnlockedStep = 0;
                lastEdrPayload = null;
                hideBasBlockedNotice();
                hideReqValidateError();
                hideContractError();
                resetJfDataAccuracyCheckbox();
                if (resultGrid) resultGrid.innerHTML = '';
                if (resultErr) {
                    resultErr.setAttribute('hidden', '');
                    resultErr.textContent = '';
                }
                if (lookupErr) {
                    lookupErr.setAttribute('hidden', '');
                    lookupErr.textContent = '';
                }
                if (confirmEntityBtn) confirmEntityBtn.style.display = '';
                clearRequisitesEditableFields();
                syncJfTabLocks();
                activateJfStep('0');
            }

            flowDemo.addEventListener('kp-jf-reset', resetJfFlowProgress);

            /** Stay on jur-entity flow step 5 after successful submit (no redirect / modal). */
            function handleJurEntityFlowSubmitSuccess(data) {
                if (data && data.company) {
                    appendCompanyRow(data.company);
                }
                hideContractError();

                const title = (data && data.success_title) || root?.dataset.jfSuccessTitle || '';
                const message = (data && data.user_message) || root?.dataset.jfSuccessMessage || '';
                const titleEl = document.getElementById('kp-jf-success-title');
                const msgEl = document.getElementById('kp-jf-success-message');
                if (titleEl && title) titleEl.textContent = title;
                if (msgEl && message) msgEl.textContent = message;

                const btn = document.getElementById('kp-jf-success-goto-companies');
                const btnLabel = root?.dataset.jfSuccessBtnLabel || '';
                const companiesUrl = root?.dataset.jfCompaniesUrl || '';
                if (btn) {
                    if (btnLabel) btn.textContent = btnLabel;
                    if (companiesUrl) btn.setAttribute('href', companiesUrl);
                }

                unlockJfTabsThrough(4);
                activateJfStep('4');
                if (flowDemo) {
                    flowDemo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }

            /**
             * Jur-entity flow step 4 — submit without legacy file upload / hidden form.
             */
            const submitJurEntityFlowCompany = () => {
                if (!lastEdrPayload || !form) {
                    const msg = 'Спочатку пройдіть кроки пошуку та підтвердження даних (кроки 1–2).';
                    showContractError(msg);
                    return;
                }

                if (lastEdrPayload.blockedInBas || isCounterpartyInBas(lastEdrPayload.data)) {
                    showContractError(
                        (lastEdrPayload.data && lastEdrPayload.data.kp_block_message) || getBasExistsMessage()
                    );
                    activateJfStep('1');
                    showBasBlockedNotice(
                        (lastEdrPayload.data && lastEdrPayload.data.kp_block_message) || getBasExistsMessage()
                    );
                    return;
                }

                const req = validateRequisitesForContract();
                if (!req.ok) {
                    showContractError(req.message);
                    return;
                }

                if (!isJfDataAccuracyConfirmed()) {
                    const wrap = document.getElementById('kp-jf-data-accuracy-wrap');
                    if (wrap) wrap.classList.add('is-invalid');
                    showContractError('Підтвердіть достовірність і точність наданих даних.');
                    return;
                }

                hideContractError();
                const accuracyWrap = document.getElementById('kp-jf-data-accuracy-wrap');
                if (accuracyWrap) accuracyWrap.classList.remove('is-invalid');
                const x = collectContractData();
                const entity = getJfContractEntity();

                const fd = new FormData();
                fd.append('action', 'add_company');
                fd.append('add_company_nonce', form['add_company_nonce'].value);
                fd.append('submit_tab', entity);
                fd.append('is_ajax', '1');
                fd.append('kp_jf_flow', '1');

                if (entity === 'fop') {
                    fd.append('fop-name', x.name);
                    fd.append('fop-code', x.code);
                    fd.append('fop-address', x.address);
                } else {
                    fd.append('company-name', x.name);
                    fd.append('company-code', x.code);
                    fd.append('company-address', x.address);
                }

                fd.append('kp_jf_contract_email', x.email);
                fd.append('kp_jf_contract_phone', normalizeJfPhone(x.phone) || x.phone);
                fd.append('kp_jf_contract_iban', x.iban);
                fd.append('kp_jf_contract_bank', x.bank);
                fd.append('kp_jf_contract_comment', x.comment);
                fd.append('kp_jf_fact_address', x.factAddress);
                fd.append('kp_jf_agent_activity', x.activity);
                fd.append('kp_jf_agent_activity_label', x.activityLabel);
                fd.append('kp_jf_signing_method', x.signingMethod);
                fd.append('kp_jf_data_accuracy_confirmed', '1');
                fd.append('kp_jf_signer', x.signer);
                fd.append('kp_jf_reg_date', x.regDate);
                fd.append('kp_jf_vat', x.vat);
                fd.append('kp_jf_registry_name', x.name);
                if (x.edrRecord) {
                    fd.append('kp_jf_edr_record', x.edrRecord);
                }
                if (x.edrRecordDate) {
                    fd.append('kp_jf_edr_record_date', x.edrRecordDate);
                }
                if (x.epGrup) {
                    fd.append('kp_jf_ep_grup', x.epGrup);
                }
                if (x.epStavka) {
                    fd.append('kp_jf_ep_stavka', x.epStavka);
                }
                if (x.taxStatus) {
                    fd.append('kp_jf_tax_status', x.taxStatus);
                }

                const createBtn = document.getElementById('kp-jf-contract-create');
                const createBtnLabel = createBtn ? createBtn.textContent : '';
                if (createBtn) {
                    createBtn.disabled = true;
                    createBtn.textContent = 'Відправлення…';
                }

                const postUrl = ajaxView || ajaxUrl;
                if (!postUrl) {
                    const msg = 'Не вдалося надіслати заявку. Оновіть сторінку.';
                    showContractError(msg);
                    if (createBtn) {
                        createBtn.disabled = false;
                        createBtn.textContent = createBtnLabel;
                    }
                    return;
                }

                fetch(postUrl, {
                    method: 'POST',
                    body: fd,
                })
                    .then((r) => r.json())
                    .then((data) => {
                        if (data && data.success) {
                            handleJurEntityFlowSubmitSuccess(data);
                        } else {
                            const msg =
                                (data && data.message) ||
                                'Не вдалося зберегти заявку. Спробуйте ще раз або зверніться до підтримки.';
                            showContractError(msg);
                            if (
                                lastEdrPayload &&
                                (lastEdrPayload.blockedInBas || isCounterpartyInBas(lastEdrPayload.data))
                            ) {
                                activateJfStep('1');
                                showBasBlockedNotice(msg);
                            }
                        }
                    })
                    .catch(() => {
                        const msg = 'Мережева помилка. Перевірте з’єднання та спробуйте ще раз.';
                        showContractError(msg);
                    })
                    .finally(() => {
                        if (createBtn) {
                            createBtn.textContent = createBtnLabel;
                            syncJfContractCreateEnabled();
                        }
                    });
            };

            const dataAccuracyCb = document.getElementById('kp-jf-data-accuracy');
            if (dataAccuracyCb) {
                dataAccuracyCb.addEventListener('change', () => {
                    const wrap = document.getElementById('kp-jf-data-accuracy-wrap');
                    if (wrap) wrap.classList.remove('is-invalid');
                    hideContractError();
                    syncJfContractCreateEnabled();
                });
                syncJfContractCreateEnabled();
            }

            if (KP_JF_SUBMIT_COMPANY_ENABLED) {
                const contractCreateBtn = document.getElementById('kp-jf-contract-create');
                if (contractCreateBtn) {
                    contractCreateBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        hideReqValidateError();
                        submitJurEntityFlowCompany();
                    });
                }
            }

            function renderContractPreview() {
                if (!lastEdrPayload) return;
                hideContractError();
                const data = collectContractData();
                const summary = document.getElementById('kp-jf-contract-summary');
                if (summary) {
                    summary.textContent =
                        'Перевірте реквізити нижче. Договір DOCX можна завантажити для ознайомлення до підтвердження заявки.';
                }
                const list = document.getElementById('kp-jf-contract-buyer-list');
                if (list) {
                    const rows = [
                        ['Назва', data.name],
                        [lastEdrPayload.entity === 'fop' ? 'ІПН' : 'ЄДРПОУ', data.code],
                        ['Адреса', data.address],
                        ['Фактична адреса та назва закладу', data.factAddress],
                        ['Email', data.email],
                        ['Телефон', data.phone || '—'],
                        ['IBAN', data.iban],
                        ['Банк', data.bank],
                        ['Підписант', data.signer],
                    ];
                    if (data.regDate) rows.push(['Дата реєстрації', data.regDate]);
                    if (data.vat) rows.push(['ПДВ', data.vat]);
                    if (data.activityLabel) rows.push(['Вид діяльності', data.activityLabel]);
                    if (data.signingMethod) {
                        rows.push([
                            'Підписання',
                            data.signingMethod === 'postal' ? 'Поштова відправка' : 'Вчасно',
                        ]);
                    }
                    list.innerHTML = rows
                        .filter(([, v]) => v)
                        .map(([k, v]) => `<li><strong>${escapeHtml(k)}:</strong> ${escapeHtml(v)}</li>`)
                        .join('');
                    list.hidden = list.innerHTML === '';
                }
            }

            async function downloadContractDocx(triggerBtn) {
                if (!lastEdrPayload) {
                    showContractError('Спочатку знайдіть та підтвердіть юрособу в реєстрі (кроки 1–2).');
                    return;
                }
                const check = validateRequisitesForContract();
                if (!check.ok) {
                    showContractError(check.message);
                    return;
                }
                hideContractError();
                const data = collectContractData();
                const entity = getJfContractEntity();
                const ajaxUrl = typeof main !== 'undefined' && main.ajaxUrl ? main.ajaxUrl : '';
                const nonce = typeof main !== 'undefined' && main.nonce ? main.nonce : '';
                if (!ajaxUrl || !nonce) {
                    showContractError('Не вдалося ініціалізувати завантаження. Оновіть сторінку.');
                    return;
                }

                const fd = new FormData();
                fd.append('action', 'kitan_sync_bas_download_contract');
                fd.append('nonce', nonce);
                fd.append('entity', entity);
                fd.append('buyer_name', data.name);
                fd.append('buyer_edr', data.code);
                fd.append('buyer_address', data.address);
                fd.append('buyer_chief', data.signer);
                fd.append('buyer_email', data.email);
                fd.append('buyer_phone', normalizeJfPhone(data.phone) || data.phone);
                fd.append('buyer_iban', data.iban);
                fd.append('buyer_bank', data.bank);
                fd.append('buyer_vat', data.vat || '');
                fd.append('buyer_reg_date', data.regDate || '');
                if (data.edrRecord) {
                    fd.append('buyer_edr_record', data.edrRecord);
                }
                if (data.edrRecordDate) {
                    fd.append('buyer_edr_record_date', data.edrRecordDate);
                }
                if (data.epGrup) {
                    fd.append('buyer_ep_grup', data.epGrup);
                }
                if (data.epStavka) {
                    fd.append('buyer_ep_stavka', data.epStavka);
                }
                if (data.taxStatus) {
                    fd.append('buyer_tax_status', data.taxStatus);
                }

                const buttons = flowDemo.querySelectorAll('.kp-jf-contract-download-btn');
                const prevLabels = [];
                buttons.forEach((btn) => {
                    prevLabels.push(btn.textContent);
                    btn.disabled = true;
                });
                if (triggerBtn) {
                    triggerBtn.textContent = 'Завантаження…';
                }

                try {
                    const res = await fetch(ajaxUrl, {
                        method: 'POST',
                        body: fd,
                        credentials: 'same-origin',
                    });
                    if (!res.ok) {
                        const errText = (await res.text()).replace(/<[^>]+>/g, ' ').trim();
                        showContractError(errText || 'Не вдалося згенерувати договір. Спробуйте ще раз.');
                        return;
                    }
                    const blob = await res.blob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `contract-preview-${entity}.docx`;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        URL.revokeObjectURL(url);
                        a.remove();
                    }, 500);
                } catch (e) {
                    showContractError('Мережева помилка. Перевірте з’єднання та спробуйте ще раз.');
                } finally {
                    buttons.forEach((btn, i) => {
                        btn.disabled = false;
                        btn.textContent = prevLabels[i] || btn.textContent;
                    });
                }
            }

            const jfLegendBlocks = flowDemo.querySelectorAll('[data-kp-jf-legend-step]');

            function activateJfStep(step) {
                const stepStr = String(step);
                const stepNum = parseInt(stepStr, 10);
                if (!Number.isNaN(stepNum) && stepNum > jfMaxUnlockedStep) {
                    return false;
                }
                jfTabs.forEach((b) => {
                    const tabStep = parseInt(b.getAttribute('data-kp-jf-step'), 10);
                    const on = b.getAttribute('data-kp-jf-step') === stepStr;
                    const visited = !Number.isNaN(tabStep) && !Number.isNaN(stepNum) && tabStep < stepNum;
                    b.classList.toggle('is-active', on);
                    b.classList.toggle('is-visited', visited);
                    b.setAttribute('aria-selected', on ? 'true' : 'false');
                });
                jfPanels.forEach((p) => {
                    const show = p.getAttribute('data-kp-jf-panel') === stepStr;
                    p.toggleAttribute('hidden', !show);
                });
                jfLegendBlocks.forEach((block) => {
                    block.toggleAttribute('hidden', block.getAttribute('data-kp-jf-legend-step') !== stepStr);
                });
                if (stepStr === '2') {
                    fillRequisitesPanel();
                    loadJfActivities(false);
                }
                if (stepStr === '3') {
                    renderContractPreview();
                    syncJfContractCreateEnabled();
                }
                return true;
            }

            jfTabs.forEach((btn) => {
                btn.addEventListener('click', () => {
                    if (btn.getAttribute('data-kp-jf-locked') === '1') return;
                    const target = parseInt(btn.getAttribute('data-kp-jf-step'), 10);
                    if (Number.isNaN(target) || target > jfMaxUnlockedStep) return;
                    activateJfStep(btn.getAttribute('data-kp-jf-step'));
                });
            });

            function activateJfEntityTab(entity) {
                const ent = entity === 'fop' ? 'fop' : 'legal';
                flowDemo.querySelectorAll('.kp-jf-entity-tab').forEach((t) => {
                    t.classList.toggle('is-active', t.getAttribute('data-kp-jf-entity') === ent);
                });
                if (codeLabel) codeLabel.textContent = JF_LABEL[ent] || JF_LABEL.legal;
                if (edrInput) edrInput.placeholder = JF_PH[ent] || JF_PH.legal;
                const reqCodeLbl = document.getElementById('kp-jf-req-code-lbl');
                if (reqCodeLbl) reqCodeLbl.textContent = ent === 'fop' ? 'ІПН' : 'ЄДРПОУ / ІПН';
            }

            flowDemo.querySelectorAll('.kp-jf-signing-opt').forEach((btn) => {
                btn.addEventListener('click', () => {
                    setSigningMethod(btn.getAttribute('data-kp-jf-signing') || 'vchasno');
                    hideReqValidateError();
                });
            });

            flowDemo.querySelectorAll('.kp-jf-entity-tab').forEach((tab) => {
                tab.addEventListener('click', () => {
                    activateJfEntityTab(tab.getAttribute('data-kp-jf-entity') || 'legal');
                });
            });

            flowDemo.querySelectorAll('.kp-jf-demo-code').forEach((btn) => {
                btn.addEventListener('click', () => {
                    const code = btn.getAttribute('data-code') || '';
                    const ent = btn.getAttribute('data-kp-jf-entity') || 'legal';
                    if (edrInput) edrInput.value = code.replace(/\D/g, '');
                    activateJfEntityTab(ent);
                    if (lookupErr) {
                        lookupErr.setAttribute('hidden', '');
                        lookupErr.textContent = '';
                    }
                });
            });

            if (edrInput) {
                edrInput.addEventListener('input', () => {
                    edrInput.value = edrInput.value.replace(/\D/g, '');
                });
            }

            const reqIban = document.getElementById('kp-jf-req-iban');
            if (reqIban) {
                reqIban.addEventListener('input', () => {
                    let v = reqIban.value.replace(/\s/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
                    if (v.length > 29) v = v.slice(0, 29);
                    reqIban.value = v;
                    hideReqValidateError();
                });
            }

            const reqPhone = document.getElementById('kp-jf-req-phone');
            if (reqPhone) {
                reqPhone.addEventListener('input', () => {
                    hideReqValidateError();
                });
                reqPhone.addEventListener('blur', () => {
                    const normalized = normalizeJfPhone(reqPhone.value);
                    if (normalized) {
                        reqPhone.value = normalized;
                    }
                    hideReqValidateError();
                });
            }

            ['kp-jf-req-email', 'kp-jf-req-bank', 'kp-jf-req-comment'].forEach((rid) => {
                const el = document.getElementById(rid);
                if (el) {
                    el.addEventListener('input', () => {
                        hideReqValidateError();
                    });
                }
            });

            function renderEdrResult(row) {
                if (!resultGrid || !resultErr || !confirmEntityBtn) return;
                hideBasBlockedNotice();
                resultErr.setAttribute('hidden', '');
                resultErr.textContent = '';
                const d = row && row.data ? row.data : {};
                const st = parseInt(d.status, 10);
                if (Number.isNaN(st)) {
                    resultGrid.innerHTML = '';
                    resultErr.removeAttribute('hidden');
                    resultErr.textContent = 'Некоректна відповідь сервера.';
                    confirmEntityBtn.style.display = 'none';
                    return;
                }
                if (st === 0) {
                    resultGrid.innerHTML = '';
                    resultErr.removeAttribute('hidden');
                    resultErr.textContent = d.description || 'Помилка пошуку.';
                    confirmEntityBtn.style.display = 'none';
                    if (confirmTitle) confirmTitle.textContent = 'Перевірка коду';
                    if (confirmLead) confirmLead.textContent = '';
                    return;
                }
                const blockedInBas = isCounterpartyInBas(d);
                confirmEntityBtn.style.display = blockedInBas ? 'none' : '';
                if (confirmTitle) {
                    confirmTitle.textContent = st === 2 ? 'Дані з бази' : 'Дані знайдено в реєстрі';
                }
                if (confirmLead) {
                    confirmLead.textContent = blockedInBas
                        ? ''
                        : 'Перевірте автопідтягнуту інформацію та підтвердьте, що це саме ваша юридична особа.';
                }
                const cells = [];
                if (st === 2) {
                    if (d.name) cells.push({ k: 'Назва', v: d.name });
                    if (row.EDR) cells.push({ k: 'ЄДРПОУ / ІПН', v: row.EDR });
                    if (d.code) cells.push({ k: 'Код у BAS', v: d.code });
                    if (d.description) cells.push({ k: 'Статус', v: d.description, wide: true });
                } else {
                    if (d.name) cells.push({ k: 'Назва', v: d.name });
                    if (d.EDR || row.EDR) cells.push({ k: 'ЄДРПОУ / ІПН', v: d.EDR || row.EDR });
                    if (d.reg_status) cells.push({ k: 'Статус', v: d.reg_status });
                    if (d.reg_data) cells.push({ k: 'Дата реєстрації', v: d.reg_data });
                    if (d.chief) cells.push({ k: 'Керівник / підписант', v: d.chief });
                    if (d.address) cells.push({ k: 'Юридична адреса', v: d.address, wide: true });
                    if (d.tel) cells.push({ k: 'Телефон', v: d.tel });
                    if (d.vat) cells.push({ k: 'ПДВ', v: d.vat });
                    if (d.KVED) cells.push({ k: 'КВЕД', v: d.KVED, wide: true });
                    if (d.description) cells.push({ k: 'Опис', v: d.description, wide: true });
                }
                resultGrid.innerHTML = cells
                    .map(
                        (c) =>
                            `<div class="kp-jf-info-cell${c.wide ? ' kp-jf-info-cell--wide' : ''}"><div class="k">${escapeHtml(
                                c.k
                            )}</div><div class="v">${escapeHtml(c.v)}</div></div>`
                    )
                    .join('');
                if (blockedInBas) {
                    showBasBlockedNotice(d.kp_block_message || getBasExistsMessage());
                }
                clearRequisitesEditableFields();
            }

            async function runViewEdrLookup() {
                if (!lookupBtn || !edrInput) return;
                const raw = edrInput.value.replace(/\D/g, '');
                if (raw.length < 8) {
                    if (lookupErr) {
                        lookupErr.removeAttribute('hidden');
                        lookupErr.textContent = 'Введіть коректний код (мінімум 8 цифр).';
                    }
                    return;
                }
                if (lookupErr) {
                    lookupErr.setAttribute('hidden', '');
                    lookupErr.textContent = '';
                }
                lookupBtn.disabled = true;
                lookupBtn.textContent = 'Пошук…';

                if (!ajaxView || !nonceView) {
                    if (lookupErr) {
                        lookupErr.removeAttribute('hidden');
                        lookupErr.textContent = 'Немає налаштувань AJAX (main.ajaxUrl / main.nonce).';
                    }
                    lookupBtn.disabled = false;
                    lookupBtn.textContent = lookupBtnDefault;
                    return;
                }

                const fd = new FormData();
                fd.append('action', 'kitan_sync_bas_view_edr');
                fd.append('nonce', nonceView);
                fd.append('edr', raw);
                try {
                    const r = await fetch(ajaxView, { method: 'POST', body: fd, credentials: 'same-origin' });
                    const j = await r.json();
                    if (!j.success) {
                        const msg = (j.data && j.data.message) || 'Помилка запиту.';
                        const wait =
                            (j.data && j.data.data && j.data.data.wait_seconds) ||
                            (j.data && j.data.wait_seconds) ||
                            null;
                        if (lookupErr) {
                            lookupErr.removeAttribute('hidden');
                            lookupErr.textContent = wait ? `${msg} (${wait} с)` : msg;
                        }
                        return;
                    }
                    const res = j.data && j.data.result !== undefined ? j.data.result : null;
                    if (!Array.isArray(res) || res.length === 0) {
                        if (lookupErr) {
                            lookupErr.removeAttribute('hidden');
                            lookupErr.textContent = 'Дані не знайдено.';
                        }
                        return;
                    }
                    const row = res[0];
                    const entityTab = flowDemo.querySelector('.kp-jf-entity-tab.is-active');
                    const entityHint = entityTab ? entityTab.getAttribute('data-kp-jf-entity') || 'legal' : 'legal';
                    const rowData = row.data || {};
                    const rawEdr = edrInput ? edrInput.value.replace(/\D/g, '') : '';
                    const edrCode = String(row.EDR || rawEdr).replace(/\D/g, '');
                    const entity = resolveJfEntityFromEdr(edrCode, entityHint, rowData.name || '');
                    if (entity !== entityHint) {
                        activateJfEntityTab(entity);
                    }
                    lastEdrPayload = {
                        entity,
                        row,
                        data: rowData,
                        blockedInBas: isCounterpartyInBas(rowData),
                    };
                    renderEdrResult(row);
                    setJfMaxUnlockedStep(1);
                    activateJfStep('1');
                } catch (e) {
                    if (lookupErr) {
                        lookupErr.removeAttribute('hidden');
                        lookupErr.textContent = 'Мережева помилка. Спробуйте ще раз.';
                    }
                } finally {
                    lookupBtn.disabled = false;
                    lookupBtn.textContent = lookupBtnDefault;
                }
            }

            if (lookupBtn) lookupBtn.addEventListener('click', () => runViewEdrLookup());

            if (backSearchBtn) {
                backSearchBtn.addEventListener('click', () => {
                    setJfMaxUnlockedStep(0);
                    lastEdrPayload = null;
                    hideReqValidateError();
                    if (resultGrid) resultGrid.innerHTML = '';
                    if (resultErr) {
                        resultErr.setAttribute('hidden', '');
                        resultErr.textContent = '';
                    }
                    hideBasBlockedNotice();
                    if (confirmEntityBtn) confirmEntityBtn.style.display = '';
                    clearRequisitesEditableFields();
                    activateJfStep('0');
                });
            }

            if (confirmEntityBtn) {
                confirmEntityBtn.addEventListener('click', () => {
                    if (!lastEdrPayload || !form) return;
                    if (lastEdrPayload.blockedInBas || isCounterpartyInBas(lastEdrPayload.data)) {
                        showBasBlockedNotice(
                            (lastEdrPayload.data && lastEdrPayload.data.kp_block_message) || getBasExistsMessage()
                        );
                        return;
                    }
                    const st = parseInt(lastEdrPayload.data.status, 10);
                    if (st === 0) return;
                    const d = lastEdrPayload.data;
                    const isFop = lastEdrPayload.entity === 'fop';
                    const name = d.name || '';
                    const codeVal = String(d.EDR || lastEdrPayload.row.EDR || d.code || '').replace(/\D/g, '');
                    const addr = d.address || '';
                    if (isFop) {
                        if (form['fop-name']) form['fop-name'].value = name;
                        if (form['fop-code']) form['fop-code'].value = codeVal;
                        if (form['fop-address']) form['fop-address'].value = addr;
                        document.querySelectorAll('.tabs .tab').forEach((t) => {
                            if (t.getAttribute('data-tab') === 'fop') t.click();
                        });
                    } else {
                        if (form['company-name']) form['company-name'].value = name;
                        if (form['company-code']) form['company-code'].value = codeVal;
                        if (form['company-address']) form['company-address'].value = addr;
                        document.querySelectorAll('.tabs .tab').forEach((t) => {
                            if (t.getAttribute('data-tab') === 'legal') t.click();
                        });
                    }
                    checkFormValidity();
                    unlockJfTabsThrough(2);
                    activateJfStep('2');
                    if (flowDemo) {
                        flowDemo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
            }

            const reqBackBtn = document.getElementById('kp-jf-req-back');
            if (reqBackBtn) {
                reqBackBtn.addEventListener('click', () => {
                    hideReqValidateError();
                    activateJfStep('1');
                    if (flowDemo) {
                        flowDemo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
            }

            const reqNextBtn = document.getElementById('kp-jf-req-next');
            if (reqNextBtn) {
                reqNextBtn.addEventListener('click', () => {
                    const v = validateRequisitesForContract();
                    if (!v.ok) {
                        showReqValidateError(v.message);
                        return;
                    }
                    hideReqValidateError();
                    unlockJfTabsThrough(3);
                    activateJfStep('3');
                    if (flowDemo) {
                        flowDemo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
            }

            const contractBackBtn = document.getElementById('kp-jf-contract-back');
            if (contractBackBtn) {
                contractBackBtn.addEventListener('click', () => {
                    hideContractError();
                    activateJfStep('2');
                    if (flowDemo) {
                        flowDemo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
            }

            flowDemo.addEventListener('click', (e) => {
                const downloadBtn = e.target.closest('.kp-jf-contract-download-btn');
                if (!downloadBtn) return;
                e.preventDefault();
                downloadContractDocx(downloadBtn);
            });

            syncJfTabLocks();
        }

        form.onsubmit = function (e) {
            e.preventDefault();
            submitAddCompany({});
        };
    }
});
